// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3zFl7","rootSmall":"AddTileButton_rootSmall__sS09E"};